<template>
    <PopupRouterViewDetail label="Bill Of Material Detail" @hideMethod="onHidden" :isShowCopyData="false">

        <!-- APP_DETAIL_HEADER -->

        <b-card header="Bill Of Material" class="mb-3 card-max-width">
            <b-row>
				<b-col cols="12" lg="6">
						<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part Number" id="fieldset-part-number" size="sm" :model.sync="model.partNumberId" :isRequired="false" :state="validateState('partNumberId')" :errorMessage="getErrorMessage(errorMessage.partNumberId, 'partNumberId')"   :selected="model.partNumber != null ? model.partNumber.partNumber : ''" @input="getParts" @change="updateData"  :isUpdatable="true" :isEditable="false"  :isSelectMethodExists="true" @onSelectMethod="setSelectedPartNumber" />
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(model.partNumber != null) ? model.partNumber.partName : null"  />
						<app-label label-cols-lg="12" size="sm" label="Customer" :model="(model.partNumber != null) ? (model.partNumber.customer != null) ? model.partNumber.customer.code : null : null"  />
					</b-col>
					<b-col cols="12" lg="6">
						<app-label label-cols-lg="12" size="sm" label="Part Classification" :model="(model.partNumber != null) ? (model.partNumber.partClassification != null) ? model.partNumber.partClassification.code : null : null"  />
				</b-col>

            </b-row>
        </b-card>

		<app-table-input-popup title="Bill Of Material Detal" :bordered="true" :items="billOfMaterialDetails" :fields="fieldsBillOfMaterialDetail" :busy="isDataLoading" :sort-by.sync="sortByBillOfMaterialDetail" :sort-desc.sync="sortDescBillOfMaterialDetail" small responsive
			@editButtonMethod="editRowDataBillOfMaterialDetail"
			@deleteButtonMethod="deleteRowDataBillOfMaterialDetail"
			@showPopupAddMethod="resetDataBillOfMaterialDetail()"
			@showPopupUploadMethod="showPopupUploadBillOfMaterialDetail()"
			@downloadMethod="downloadBillOfMaterialDetail()"
			@addFromClipboardMethod="addFromClipboardBillOfMaterialDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardBillOfMaterialDetail()"
			:showActionButton="false"
			:showEditButton="false"
			:showDeleteButton="false"
			:showAddButton="false"
			:showAddFromClipboardButton="false"
			:showReplaceFromClipboardButton="false"
			:showUploadButton="false"
			:showDownloadButton="false"
			:isDownloadBusy="isDownloadBillOfMaterialDetail"
			>
			<template #top-row v-if="isShowBillOfMaterialDetailFilter">
				<b-th></b-th>
				<b-th></b-th>
				<b-th stacked-heading="Part Number">
					<v-select append-to-body label="partNumber" :options="parts"  :value="filterBillOfMaterialDetail.partNumberId" :reduce="item => item.id" v-model="filterBillOfMaterialDetail.partNumberId" @search="getParts" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Used Qty">
					<b-form-input id="input-used-qty-table" v-model="filterBillOfMaterialDetail.usedQty" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Part Price">
					<v-select append-to-body label="part" :options="partPrices"  :value="filterBillOfMaterialDetail.partPriceId" :reduce="item => item.id" v-model="filterBillOfMaterialDetail.partPriceId" @search="getPartPrices" :filterable="true"></v-select>
				</b-th>

				<b-th></b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( billOfMaterialDetailPageSize * (currentBillOfMaterialDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
					<b-spinner class="align-middle text-primary"></b-spinner>
					<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(partNumber)="row">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" :id="'input-bill-of-material-detail-part-number-' + row.index" label-cols-lg="12" label="Part Number" size="sm" :model.sync="row.item.partNumberId" :state="validateState('partNumberId')" :errorMessage="getErrorMessage(errorMessage.partNumberId, 'partNumberId')"  @change="saveInputBillOfMaterialDetail(row.item)" :selected="row.item.partNumber != null ? row.item.partNumber.partNumber : ''"  @input="getParts" :loading="isPartComboLoading"   :isUpdatable="true" :isEditable="false"   :nolabel="true" />
			</template>
			<template v-slot:cell(partName)="row">
						<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.partNumber != null) ? row.item.partNumber.partName : null"  />
			</template>
			<template v-slot:cell(usedQty)="row">
				<app-input-textbox :id="'input-bill-of-material-detail-used-qty-' + row.index" label-cols-lg="12" label="Used Qty" size="sm" :model.sync="row.item.usedQty"   @change="saveInputBillOfMaterialDetail(row.item)"  :isUpdatable="true" :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(uom)="row">
						<app-label label-cols-lg="12" size="sm" label="Uom" :model="(row.item.partNumber != null) ? (row.item.partNumber.uom != null) ? row.item.partNumber.uom.code : null : null"  />
			</template>
			<!-- <template v-slot:cell(partPrice)="row">
				<app-input-combobox-autocomplete :options="partPrices" optionsLabel="part" optionsKey="id" :id="'input-bill-of-material-detail-part-price-' + row.index" label-cols-lg="12" label="Part Price" size="sm" :model.sync="row.item.partPriceId"  @change="saveInputBillOfMaterialDetail(row.item)" :selected="row.item.partPrice != null ? row.item.partPrice.partVendor : ''"  @input="getPartPrices" :loading="isPartPriceComboLoading"   :isUpdatable="true" :isEditable="false"  :nolabel="true" />
			</template>
			<template v-slot:cell(priceProduct)="row">
						<app-label label-cols-lg="12" size="sm" label="Price Product" :model="(row.item.partPrice != null) ? row.item.partPrice.priceProduct : null" :thousandSeparator="true" />
			</template> -->

			<template v-slot:form-add-detail>
				<BillOfMaterialDetailInput 
					:openPopup="isShowPopupBillOfMaterialDetail"
					:modelId="billOfMaterialDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataBillOfMaterialDetail"/>
			</template>
			<template v-slot:upload-detail>
				<BillOfMaterialDetailUpload
					:openPopup="isShowPopupUploadBillOfMaterialDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataBillOfMaterialDetail"
					:parentId="modelId"
					/>
			</template>
			<template #row-details="row">
				<b-card>
							<app-label label-cols-lg="12" size="sm" label="Part Name" :model="(row.item.partNumber != null) ? row.item.partNumber.partName : null"  />
					<app-input-textbox :id="'input-bill-of-material-detail-used-qty-' + row.index" label-cols-lg="12" label="Used Qty" size="sm" :model.sync="row.item.usedQty"   @change="saveInputBillOfMaterialDetail(row.item)" :isUpdatable="false" :isEditable="false"  />
							<app-label label-cols-lg="12" size="sm" label="Uom" :model="(row.item.partNumber != null) ? (row.item.partNumber.uom != null) ? row.item.partNumber.uom.code : null : null"  />
					<app-input-combobox-autocomplete :options="partPrices" optionsLabel="part" optionsKey="id" :id="'input-bill-of-material-detail-part-price-' + row.index" label-cols-lg="12" label="Part Price" size="sm" :model.sync="row.item.partPriceId"  @change="saveInputBillOfMaterialDetail(row.item)" :selected="row.item.partPrice != null ? row.item.partPrice.partVendor : ''"  @input="getPartPrices" :loading="isPartPriceComboLoading"  :isUpdatable="false" :isEditable="false"  />
							<app-label label-cols-lg="12" size="sm" label="Price Product" :model="(row.item.partPrice != null) ? row.item.partPrice.priceProduct : null" :thousandSeparator="true" />
				</b-card>
			</template>

		</app-table-input-popup>
        <!-- END_APP_DETAIL_HEADER -->

		<template #modal-left-button>
			<b-button @click="editAction()" size="sm" class="float-right" variant="primary">
              Edit Data
            </b-button>
        </template>

        <b-overlay :show="isBusy" no-wrap></b-overlay>
    </PopupRouterViewDetail>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import BillOfMaterial from '@/models/BillOfMaterial/BillOfMaterial';
import BillOfMaterialList from '@/models/BillOfMaterial/BillOfMaterialList';
import BillOfMaterialFilter from '@/filters/BillOfMaterial/BillOfMaterialFilter';

import PopupRouterViewDetail from '@/components/PopupRouterViewDetail';

import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppLabel from '@/components/AppLabel';
import BillOfMaterialDetail from '@/models/BillOfMaterial/BillOfMaterialDetail';
import BillOfMaterialDetailFilter from '@/filters/BillOfMaterial/BillOfMaterialDetailFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import PartPrice from '@/models/PartPrice/PartPrice';
import PartPriceFilter from '@/filters/PartPrice/PartPriceFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import BillOfMaterialDetailInput from '@/views/BillOfMaterial/BillOfMaterialDetailInput';
import BillOfMaterialDetailUpload from '@/views/BillOfMaterial/BillOfMaterialDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {
		AppInputComboboxAutocomplete,
		AppLabel,
		AppInputTextbox,
		BillOfMaterialDetailInput,BillOfMaterialDetailUpload,
		AppTableInput,
		AppTableInputPopup,
		PopupRouterViewDetail,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
			partNumberId: {required},
		},
	},
	data() {
		return {
			errorMessage : {
				partNumberId: { required : "Part Number is Required."},
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsBillOfMaterialDetail: [
				// {"frontActions": { "class" : "th-actions", "label" : ""}},
				{"no" : { "class" : "th-number d-stack-none"}}, 
				{"partNumber": { "class" : "th-part-number first-child", "label" : "Part Number", key: 'partNumber', sortable: false}}, 
				{"partName": { "class" : "th-part-name", "label" : "Part Name", key: 'partName', sortable: false}}, 
				{"usedQty": { "class" : "th-used-qty last-child", "label" : "Used Qty", key: 'usedQty', sortable: false}}, 
				{"uom": { "class" : "th-uom d-stack-none", "label" : "Uom", key: 'uom', sortable: false}}, 
				// {"partPrice": { "class" : "th-part-price d-stack-none", "label" : "Part Price", key: 'partPrice', sortable: false}}, 
				// {"priceProduct": { "class" : "th-price-product d-stack-none", "label" : "Price Product", key: 'priceProduct', sortable: false}}, 
				{"actions": { "class" : "th-actions d-stack-show", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelBillOfMaterialDetail : {},
			isShowPopupBillOfMaterialDetail : false,
			isShowPopupUploadBillOfMaterialDetail : false,
			filterBillOfMaterial : null,
			currentBillOfMaterialPage : 1,
			billOfMaterialPageSize: 10,
			sortByBillOfMaterial: '',
			sortDescBillOfMaterial: '',
			filterBillOfMaterialDetail : null,
			currentBillOfMaterialDetailPage : 1,
			billOfMaterialDetailPageSize: 10,
			sortByBillOfMaterialDetail: '',
			sortDescBillOfMaterialDetail: '',
			sortingByBillOfMaterialDetail: [],
			billOfMaterialDetails : [],
			billOfMaterialDetailId : '',
			totalBillOfMaterialDetailRow : 0,
			isShowBillOfMaterialDetailFilter: false,
			isDownloadBillOfMaterialDetail: false,
			parts: [],
			partPrices: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
			isPartComboLoading: false,
			isBillOfMaterialComboLoading: false,
			isPartPriceComboLoading: false,
		}
	},
	methods : {
		editAction(modelEvent) {
			let id = this.modelId;
			if(id != '' && id != null && id != undefined) {
				this.$router.push({ name: 'billofmaterialedit', params : { id: id } });
			}
		},
		getBillOfMaterial : async function(id) {
			this.isBusy = true;
			BillOfMaterial.getData(this, id).then(result => {
				this.model = result;
				this.mainRecordId = String(result.mainRecordId);
				let promises = Array();


				if(this.model.partNumberId != null) {
					promises.push(
						this.getPart(this.model.partNumberId).then(result => { 
							return true; 
						}).catch(error => {
							this.$store.dispatch('addErrorMessageGlobal', error);
							throw error;
						})
					);
				}

				Promise.all(promises).then((results) => {
					this.isBusy = false;
				});
			}).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadBillOfMaterial = true;
			this.filterBillOfMaterial.id = this.modelId;
			BillOfMaterial.downloadDataDetail(this, this.filterBillOfMaterial).then(result => {
				this.isDownloadBillOfMaterial = false;
			}).catch(error => { this.isDownloadBillOfMaterial = false; })
		},
		getBillOfMaterialDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterBillOfMaterialDetail);
			if (this.modelId == null) return;
			filter.billOfMaterialId = this.modelId;
			filter.draftMode = "0";
			if (this.sortByBillOfMaterialDetail != null) {
				this.sortingByBillOfMaterialDetail[this.sortByBillOfMaterialDetail] = this.sortDescBillOfMaterialDetail;
			}
			let currentPage = (this.currentBillOfMaterialDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalBillOfMaterialDetailRow + 1;
				let page = Math.ceil(totalData/this.billOfMaterialDetailPageSize);
				currentPage = page - 1;
			}
			// disable paging start
			currentPage = null;
			this.billOfMaterialDetailPageSize = 0;
			// disable paging end
			BillOfMaterialDetail.getList(this, filter, this.sortingByBillOfMaterialDetail, currentPage , this.billOfMaterialDetailPageSize).then(result => {
				this.currentBillOfMaterialDetailPage = currentPage + 1;
				this.billOfMaterialDetails = result.data;
				this.totalBillOfMaterialDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getBillOfMaterials : async function(input) {
			let filter = new BillOfMaterialFilter();
			if (input != undefined) {
				filter.PartNumber = input;
			}
			this.isBillOfMaterialComboLoading = true;
			BillOfMaterial.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfMaterials = result.data
				}
				this.isBillOfMaterialComboLoading = false;
			})
			.catch(error => {});
		},
		getBillOfMaterials : async function(input) {
			let filter = new BillOfMaterialFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isBillOfMaterialComboLoading = true;
			BillOfMaterial.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.billOfMaterials = result.data
				}
				this.isBillOfMaterialComboLoading = false;
			})
			.catch(error => {});
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			this.isPartComboLoading = true;
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
				this.isPartComboLoading = false;
			})
			.catch(error => {});
		},
		getPartPrices : async function(input) {
			let filter = new PartPriceFilter();
			if (input != undefined) {
				filter.part = input;
			}
			this.isPartPriceComboLoading = true;
			PartPrice.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.partPrices = result.data
				}
				this.isPartPriceComboLoading = false;
			})
			.catch(error => {});
		},
		setSelectedPartNumber(item) {
			if(item == undefined || item == null) {
				this.model.partNumberId = null;
				this.model.partNumber = null;
			} else {
				this.model.partNumberId = item.id;
				this.model.partNumber = item;
			}
			this.$forceUpdate();
			this.updateData();
		},
		getPart : async function(id) {
			Part.getData(this, id).then(result => {
				this.model.partNumber = result;
				this.isBusy = false;
				return result;
				}).catch(error => { });
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		handleScroll() {
			this.$refs.billOfMaterialInput.scrollTop = 0;
		},
		saveAction(modalEvent) {
			modalEvent.preventDefault();
			this.handleScroll();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isBusy = true;
				let id = this.modelId;
				let model = this.model;

				if (id != '' && id != null && id != undefined) {
					BillOfMaterial.commitData(this, model, id).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'billofmaterialindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				} else {
					BillOfMaterial.insertData(this, model).then(result => {
						this.isDataCommited = true;
						this.$router.push({ name: 'billofmaterialindex' });
						this.isBusy = false;
					}).catch(error => { this.isBusy = false; });
				}
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					BillOfMaterial.updateDataDetail(this, model, id)
					.catch((error) => {
						this.getBillOfMaterial(id);
					});
				}
			});
		},
		onHidden() {
			this.getBillOfMaterials();
		},
		addRowDataBillOfMaterialDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.billOfMaterialId =  this.modelId;
					BillOfMaterialDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getBillOfMaterialDetails(true);
						this.isShowPopupBillOfMaterialDetail = false;
					})
				} else {
					model.billOfMaterialId =  this.modelId;
					BillOfMaterialDetail.createDataDetail(this, model)
					.then(result => {
						this.getBillOfMaterialDetails(true);
						this.isShowPopupBillOfMaterialDetail = false;
					})
				}
			}
		},
		async editRowDataBillOfMaterialDetail(id) {
			this.billOfMaterialDetailId = id;
			this.isShowPopupBillOfMaterialDetail = true; 
		},
		async deleteRowDataBillOfMaterialDetail(id) {
			BillOfMaterialDetail.deleteData(this, id).then(result => { this.getBillOfMaterialDetails(); });
		},
		async resetDataBillOfMaterialDetail() {
			this.billOfMaterialDetailId = "";
			this.isShowPopupBillOfMaterialDetail = true;
		},
		async addDataBillOfMaterialDetail() {
			BillOfMaterialDetail.createData(this, { billOfMaterialId: this.modelId })
			.then(result => {
				this.getBillOfMaterialDetails(true);
			})
		},
		async addFromClipboardBillOfMaterialDetail() {
			let partNumbers = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					partNumbers.push({ partNumber: item, billOfMaterialId: this.modelId });
				});
				BillOfMaterialDetail.addFromClipboard(this, partNumbers).then(result => { this.getBillOfMaterialDetails() });
			});
		},
		async replaceFromClipboardBillOfMaterialDetail() {
			let partNumbers = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					partNumbers.push({ partNumber: item, billOfMaterialId: this.modelId });
				});
				BillOfMaterialDetail.replaceFromClipboard(this, partNumbers).then(result => { this.getBillOfMaterialDetails() });
			});   
		},
		showPopupUploadBillOfMaterialDetail() {
			this.isShowPopupUploadBillOfMaterialDetail = true;
		},
		uploadDataBillOfMaterialDetail(modalEvent, newDatas) {
			this.isShowPopupUploadBillOfMaterialDetail = false; 
		},
		downloadBillOfMaterialDetail(modalEvent) {
			this.isDownloadBillOfMaterialDetail = true;
			this.filterBillOfMaterialDetail.billOfMaterialId = this.modelId;
			BillOfMaterialDetail.downloadDataDetail(this, this.filterBillOfMaterialDetail).then(result => {
				this.isDownloadBillOfMaterialDetail = false;
			}).catch(error => { this.isDownloadBillOfMaterialDetail = false; })
		},
		saveInputBillOfMaterialDetail(item) {
			if (this.billOfMaterials != null && this.billOfMaterials != undefined  && this.billOfMaterials.length > 0) {
				item.billOfMaterial = this.billOfMaterials.find(q => q.id == item.billOfMaterialId);
			}
			if (this.parts != null && this.parts != undefined  && this.parts.length > 0) {
				item.partNumber = this.parts.find(q => q.id == item.partNumberId);
			}
			if (this.partPrices != null && this.partPrices != undefined  && this.partPrices.length > 0) {
				item.partPrice = this.partPrices.find(q => q.id == item.partPriceId);
			}

			let id = item.id;
			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					BillOfMaterialDetail.updateDataDetail(this, item, item.id);
				}
			});
		},
		resetModal(modalType) {
			this.isShowPopupUploadBillOfMaterialDetail = false; 
			this.isShowPopupBillOfMaterialDetail = false; 
			if (modalType == 'BillOfMaterialDetail') {
				this.getBillOfMaterialDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				//this.isShowBillOfMaterialDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterBillOfMaterial = new BillOfMaterialFilter();
		this.filterBillOfMaterialDetail = new BillOfMaterialDetailFilter();
		//this.getBillOfMaterials();
		//this.getParts();
		//this.getPartPrices();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getBillOfMaterial(id);
			} else {
				this.modelId = id;
				this.getBillOfMaterial(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
		isAllowSaveDraft: {
			get: function() {
				if(this.model.mainRecordId != undefined || this.model.mainRecordId != null) return false;
				return true;
			}
		}
	},
	watch : {
		sortByBillOfMaterialDetail : {
			handler: function() {
				this.getBillOfMaterialDetails();
			}
		},
		sortDescBillOfMaterialDetail: {
			handler: function() {
				this.getBillOfMaterialDetails();
			}
		},
		currentBillOfMaterialDetailPage: {
			handler: function() {
				this.getBillOfMaterialDetails();
			}
		},
		billOfMaterialDetailPageSize : {
			handler: function() {
				this.getBillOfMaterialDetails();
			}
		},
		filterBillOfMaterialDetail: {
			handler: function() {
				this.getBillOfMaterialDetails();
			},
			deep: true,
		},
	},
}
</script>
